import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import { findKnowledgeBaseByIdOrGetDefault } from '../knowledge-base/utils/findKnowledgeBaseByIdOrGetDefault';
import KnowledgeBaseTranslatedContentRecord from '../records/KnowledgeBaseTranslatedContentRecord';
const fromJS = translatedContent => ImmutableMap(Object.keys(translatedContent).map(lang => [lang, KnowledgeBaseTranslatedContentRecord.fromJS(translatedContent[lang])]));
const INITIAL_STATE = ImmutableMap({
  data: null,
  lastLoaded: null,
  loading: false
});
export default function templateTranslations(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.FETCH_TEMPLATE_TRANSLATIONS_PENDING:
      return state.set('loading', true);
    case ActionTypes.FETCH_TEMPLATE_TRANSLATIONS_ERROR:
      return state.set('loading', false);
    case ActionTypes.FETCH_KNOWLEDGE_BASE_SUCCESS:
      {
        const {
          knowledgeBases,
          requestedKnowledgeBaseId
        } = action.payload;
        const knowledgeBase = findKnowledgeBaseByIdOrGetDefault(knowledgeBases.objects, requestedKnowledgeBaseId);
        if (knowledgeBase) {
          return state.merge({
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            loading: false,
            lastLoaded: new Date().valueOf(),
            data: fromJS(knowledgeBase.translatedContent)
          });
        }
        return state;
      }
    case ActionTypes.UPDATE_KNOWLEDGE_BASE_SUCCESS:
      {
        const updated = action.payload.translatedContent;
        if (updated) {
          return state.merge({
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            lastLoaded: new Date().valueOf(),
            data: fromJS(updated)
          });
        }
        return state;
      }
    default:
      return state;
  }
}